import { EnvironmentProviders } from '@angular/core'

import { definePreset } from '@primeng/themes'
import Lara from '@primeng/themes/lara'
import { providePrimeNG } from 'primeng/config'

const PresetLara = definePreset(Lara, {
  semantic: {
    primary: {
      50: 'var(--color-primary-50)',
      100: 'var(--color-primary-100)',
      200: 'var(--color-primary-200)',
      300: 'var(--color-primary-300)',
      400: 'var(--color-primary-400)',
      500: 'var(--color-primary-500)',
      600: 'var(--color-primary-600)',
      700: 'var(--color-primary-700)',
      800: 'var(--color-primary-700)',
      900: 'var(--color-primary-700)',
      950: 'var(--color-primary-700)',
    },
    // Masks follow the shared backdrop in libs/core/ui-kit/src/styles/backdrop.scss
    mask: {
      transitionDuration: 'var(--backdrop-duration)',
    },
    colorScheme: {
      light: { mask: { background: 'var(--backdrop-color)' } },
      dark: { mask: { background: 'var(--backdrop-color)' } },
    },
  },
})

export const providePrimeNgPreset = (): EnvironmentProviders => {
  return providePrimeNG({
    theme: {
      preset: PresetLara,
      options: {
        darkModeSelector: '.dark-mode', // Not supported yet
      },
    },
  })
}
